import {CHANGE_PARAMETER, QUOTE_SUCCESS, SELECT_PRICE_SUCCESS} from "../../shared/pu-redux/actions/QuoteActions";

const parameterForceRequote = name => name === 'mylar_material' || name === 'mylar_length' ||  name === 'mylar_width';

const parameters_changed = (state = false, action) => {
  switch (action.type) {
    case CHANGE_PARAMETER:
      return parameterForceRequote(action.name);

    case QUOTE_SUCCESS:
      return false;

    // case SELECT_PRICE_SUCCESS:
    //   return false;

    default:
      return state;
  }
};

export default parameters_changed;
